import angular from 'angular';
import 'components/sharpr/cfg/cfgModule';

import { AutoArchiveService } from './AutoArchiveService';

angular.module('sh.autoArchive', ['sh.cfg']).service('AutoArchive', AutoArchiveService);
